import {useLazyQuery} from '@apollo/client';
import {useNavigate} from 'react-router-dom';
import {OV_RECOMMENDATION_DETAILS} from '../features/recommendations/RecommendsGrid/ovPotQueries';
import {
  OvrecommendDetails,
  OvrecommendDetailsVariables,
} from '../schema-types/OvrecommendDetails';

export default function useOVRecommendDetails() {
  const navigate = useNavigate();
  const [queryGetOVRecommendationDetails, {data, error, loading}] = useLazyQuery<
    OvrecommendDetails,
    OvrecommendDetailsVariables
  >(OV_RECOMMENDATION_DETAILS);

  return {
    queryGetOVRecommendationDetails,
    ovRecommendationData: data?.ovrecommendDetails,
    loadingOvRecommend: loading,
  };
}
